/* eslint-disable @typescript-eslint/ban-ts-comment */
// 神策埋点
import { langHostEnv, version } from "@/i18n/utils/host";
import { host, sensorsEnv } from "@/utils";

const getServerUrl = (): string => {
  const envName = process.env.ENV_NAME;
  // 文档：https://es3eflgtuw.feishu.cn/wiki/E6V5wVfGWiJQY6kr2abcxgoinyb
  switch (envName) {
    case host.production:
      return "//receiver.golingo.cn/receiver/api/gp?project=glsp-home&token=ceebecc670a4e7d30f95bd78e9fb4884";
    case host.local:
      // 本地使用测试项目埋点
      return "//dev-receiver.golingo.cn/receiver/api/gp?project=glsp&token=14e4dee7dcaf82197d7281744a7944b3";
    default:
      return "//dev-receiver.golingo.cn/receiver/api/gp?project=glsp-home&token=ceebecc670a4e7d30f95bd78e9fb4884";
  }
};

/**
 * 初始化埋点
 * @param userId: ssoId     project: glsp
 */
export const initSensors = async (userId?: string): Promise<any> => {
  if (sensorsEnv) {
    const sensors = (await import("sa-sdk-javascript")).default;
    // @ts-expect-error
    const sessionEvent = (await import("sa-sdk-javascript/dist/web/plugin/session-event/index.es6"))
      .default;
    // @ts-expect-error
    const pageleave = (await import("sa-sdk-javascript/dist/web/plugin/pageleave/index.es6.js"))
      .default;

    sensors.init({
      server_url: getServerUrl(),
      // 表示是否开启单页面自动采集 $pageview 功能，SDK 会在 url 改变之后自动采集web页面浏览事件 $pageview。
      is_track_single_page: true,
      use_client_time: true,
      show_log: langHostEnv.isLocal,
      // show_log: false,
      send_type: "beacon",
      heatmap: {
        // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
        clickmap: "not_collect",
        // 是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
        scroll_notice_map: "not_collect",
      },
    });

    // 注册公共属性
    sensors.registerPage({
      current_url: location.href,
      referrer: document.referrer,
      version, // 必须添加版本号，根据项目版本自行定义
      distinct_name: userId, // 必填，传账号
    });

    sensors.quick("autoTrack"); // 用于采集 $pageview 事件。
    // 注册公共属性
    sensors.registerPage({
      current_url: location.href,
      referrer: document.referrer,
    });

    // 添加插件，否则用户画像无法查看
    sensors.use(sessionEvent, {});

    if (userId !== undefined) {
      sensors.login(userId);
    } else {
      sensors.quick("isReady", function () {
        const anonymousID = sensors.quick("getAnonymousID");
        // 设置登陆id
        sensors.login(anonymousID);
      });
    }
    // 页面时长统计,统计流量质量指标
    sensors.use(pageleave, {
      custom_props: {
        // 页面浏览时长自定义属性，可选
        prop1: "value1",
      },
      heartbeat_interval_time: 5,
      max_duration: 5 * 24 * 60 * 60,
      isCollectUrl: function (url: any) {
        // url 为要采集页面浏览时长的页面地址。
        return true; // 采集
        // return false; // 不采集
      },
    });

    return sensors;
  }
};

// 手动埋点方法
export const track = (event: string, options?: any): void => {
  if (sensorsEnv) {
    const newOption = options !== undefined ? options : {};
    window.sa.track(event, newOption);
  }
};
